import LoginForm from "app/features/authentication/templates/LoginForm";

export default function LoginScreen() {
  return <LoginForm />;
}
